import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fill-height bg_auth" }
const _hoisted_2 = { class: "d-flex justify-center mb-4" }
const _hoisted_3 = { class: "pt-4 pb-4 d-flex justify-center" }
const _hoisted_4 = { class: "form pt-4 pb-4" }
const _hoisted_5 = { class: "d-flex justify-end mr-8 align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_RegisterButton = _resolveComponent("RegisterButton")!
  const _component_InfoPage = _resolveComponent("InfoPage")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_img, {
        src: "/img/bobbee_logo_3.png",
        height: !_ctx.$vuetify.display.mobile ? '10vh' : '',
        width: !_ctx.$vuetify.display.mobile ? '' : '20vw'
      }, null, 8, ["height", "width"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RegisterButton, {
          step: _ctx.step,
          "onUpdate:step": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step) = $event)),
          offer: _ctx.data.offer,
          loading: _ctx.loading,
          ended: _ctx.ended,
          onValidNextStep: _ctx.triggerValidNextStep
        }, null, 8, ["step", "offer", "loading", "ended", "onValidNextStep"]),
        _createVNode(_component_InfoPage, {
          data: _ctx.data,
          "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data) = $event)),
          step: _ctx.step,
          "onUpdate:step": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step) = $event)),
          onUserFormValidation: _ctx.userFormValidation,
          onCompanyFormValidation: _ctx.companyFormValidation
        }, null, 8, ["data", "step", "onUserFormValidation", "onCompanyFormValidation"])
      ])
    ]),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "9" }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("small", { class: "d-flex justify-center align-center mr-24" }, [
              _createTextVNode("This site is protected by reCAPTCHA and the Google "),
              _createElementVNode("a", { href: "https://policies.google.com/privacy" }, " Privacy Policy "),
              _createTextVNode(" and "),
              _createElementVNode("a", { href: "https://policies.google.com/terms" }, " Terms of Service "),
              _createTextVNode(" apply. ")
            ], -1)
          ])),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "1" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_btn, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.login())),
                variant: "text"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Se connecter ? ")
                ])),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}